import { resolveColorVariant } from './resolveColorVariant';
const iconStartStyleDecorator = (variant, theme) => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.tokens.ComponentBadgeIconSize,
    color: resolveColorVariant(variant, theme) ?? theme.tokens.ComponentBadgeIconDefaultColor
  };
};
const iconEndStyleDecorator = (variant, theme) => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.tokens.ComponentBadgeIconSize,
    color: resolveColorVariant(variant, theme) ?? theme.tokens.ComponentBadgeIconDefaultColor
  };
};
export { iconStartStyleDecorator, iconEndStyleDecorator };